const StrokeStyleString = {
  0: "Dominant",
  1: "Nondominant",
  2: "Head Only",
  3: "Shaft Only",
  4: "Overhand Grip",
}

const StrokeStyleEnum = {
  Dominant: 0,
  Nondominant: 1,
  HeadOnly: 2,
  ShaftOnly: 3,
  OverhandGrip: 4,
}

export { StrokeStyleString, StrokeStyleEnum }



// WEBPACK FOOTER //
// ./src/game/enums/StrokeStyle.js